import React from 'react'

const Spinner: React.FC<{ size?: number }> = ({ size = 36 }) => {
    const s = size;
    return (
        <div className="flex items-center justify-center w-full">
            <svg
                style={{ width: s, height: s }}
                className="animate-spin text-primary"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" className="opacity-25" fill="none" />
                <path
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    className="opacity-75"
                />
            </svg>
        </div>
    )
}

export default Spinner
